
import { MapLocation } from '@/types/location';

// Celebrity Center Locations
export const celebrityCenters: MapLocation[] = [
  {
    id: 52001,
    name: "Celebrity Center - Riyadh (Al Khaleej)",
    type: "Game Center",
    devices: 5,
    coordinates: [24.788000195937347, 46.811486012722234],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
